import { Button } from '@mantine/core';

interface ActionButtonProps {
  onClick: () => void;
  label: string;
  ariaLabel?: string;
  actionType?: 'primary' | 'secondary' | 'danger';
  isLoading?: boolean;
  isSubmit?: boolean;
  disabled?: boolean;
  width?: number | string;
  leftIcon?: React.ReactNode;
  sx?: any;
}

export function ActionButton({ 
  onClick, 
  label, 
  ariaLabel, 
  actionType = 'primary',
  isLoading = false,
  isSubmit = false,
  disabled = false,
  width,
  leftIcon,
  sx
}: ActionButtonProps) {
  return (
    <Button 
      variant={actionType === 'primary' ? "filled" : "outline"}
      onClick={onClick}
      aria-label={ariaLabel ?? label}
      disabled={disabled || isLoading}
      sx={(theme) => ({
        width: width,
        ...(actionType === 'primary' ? {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.black,
          color: theme.white,
          '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.fn.darken(theme.black, 0.1),
          }
        } : {
          borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
          color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
          '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' 
              ? theme.fn.rgba(theme.colors.dark[0], 0.1)
              : theme.fn.rgba(theme.black, 0.05),
          }
        }),
        '@media (max-width: 480px)': {
          width: '100%',
          minHeight: 44
        },
        ...(typeof sx === 'function' ? sx(theme) : sx)
      })}
      loading={isLoading}
      type={isSubmit ? 'submit' : 'button'}
      leftIcon={leftIcon}
    >
      {label}
    </Button>
  );
} 
